import React from 'react';
import Head from 'next/head';

export default function Meta(props) {
  const { property, content } = props;
  const isOpenGraphProperty = property.startsWith('og:');

  return (
    <Head>
      <meta key={property} {...(isOpenGraphProperty ? { property } : { name: property })} content={content} />
    </Head>
  );
}
